import styled from "styled-components";

export const ProgramVideoListStyled = styled.div`
  padding: 24px 0;
`;
